import React from 'react';

export default function Resume() {
	return (
		<div class="embed-responsive" style={{ height: "100vh" }}>
			<embed
				src="/ngmunhin_resume.pdf"
				type="application/pdf"
				width="100%"
				height="100%"
			/>
		</div>
	)
}